exports = module.exports = require("../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".react-spinner{position:relative;width:32px;height:32px;top:50%;left:50%}.react-spinner_bar{animation:react-spinner_spin 1.2s linear infinite;border-radius:5px;background-color:#fff;position:absolute;width:20%;height:7.8%;top:-3.9%;left:-10%}@keyframes react-spinner_spin{0%{opacity:1}to{opacity:.15}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/@jimpick/react-spinner/react-spinner.css
// module id = 1277
// module chunks = 2